/**
 * Centralized gate for the transcript delta-updates rollout.
 *
 * The `REACT_APP_DELTA_UPDATES` env var acts as a master kill-switch. On top
 * of that, we progressively enable the feature for specific workflow shapes.
 * Today we only enable it for `job_type === "batch"`. Future rollout phases
 * should add additional criteria here so that call sites do not have to
 * change.
 */
export const isDeltaUpdatesEnabledForWorkflow = (workflowData) => {
  const default_enabled_envs = ["development", "staging"];
  const REACT_APP_DELTA_UPDATES = process.env.REACT_APP_DELTA_UPDATES;

  // In development and staging, we enable delta updates by default for all files
  if (default_enabled_envs.includes(process.env.REACT_APP_ENV) && REACT_APP_DELTA_UPDATES === "true") {
    return true;
  }

  // For prod, we don't enable delta updates by default
  if (REACT_APP_DELTA_UPDATES !== "true") {
    return false;
  }

  // On prod, only enabled for batch files
  const jobType = workflowData?.job_type;

  return jobType === "batch";
};
